import { render, staticRenderFns } from "./TagCreateModal.vue?vue&type=template&id=6402e3e2&"
import script from "./TagCreateModal.vue?vue&type=script&lang=js&"
export * from "./TagCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports